import { LyneButton } from "components/Lyne/LyneButton";
import { useSuggestedAgendaItemPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const SuggestedAgendaItemsPanelFooter: React.FC = () => {
  const i18n = useTranslations();
  const { selectedIds, onMove, onDelete, closePanel } = useSuggestedAgendaItemPanel();

  return (
    <div className="d-flex">
      <div className="mr-auto">
        <LyneButton onClick={closePanel} text={i18n.Actions_Close} kind="ghost" />
      </div>
      <div>
        <LyneButton
          className="mr-4"
          onClick={(e) => {
            e.preventDefault();
            onMove();
          }}
          disabled={selectedIds.size === 0}
          text={i18n.SuggestedAgendaItems_Move}
        />
        <LyneButton
          className="mr-2"
          onClick={(e) => {
            e.preventDefault();
            onDelete();
          }}
          disabled={selectedIds.size === 0}
          text={i18n.SuggestedAgendaItems_Delete}
          kind="secondary"
        />
      </div>
    </div>
  );
};
